export const outcomeGoalMetrics = ["referrals", "careStarts", "movesCompleted"];
export const outcomeGoalMetricLabels = {
    referrals: "Referrals received",
    careStarts: "Care started",
    movesCompleted: "Moves completed",
};
export const outcomeGoalMetricShortLabels = {
    referrals: "Referrals",
    careStarts: "Care started",
    movesCompleted: "Moves",
};
export const isOutcomeGoalMetric = (key) => outcomeGoalMetrics.includes(key);
const outcomeGoalMetricsByCrmMode = {
    "placement-only": ["referrals", "movesCompleted"],
    "home-care-only": ["referrals", "careStarts"],
    combined: ["referrals", "careStarts", "movesCompleted"],
    none: ["referrals", "careStarts", "movesCompleted"],
};
export const outcomeGoalMetricsForCrmMode = (mode) => outcomeGoalMetricsByCrmMode[mode];
export const zeroTargets = () => ({
    activity: {},
    referrals: 0,
    careStarts: 0,
    movesCompleted: 0,
});
export const hasAnyGoalTarget = (targets) => outcomeGoalMetrics.some(metric => targets[metric] > 0) ||
    Object.values(targets.activity).some(target => target > 0);
export const maxMarketingGoalRangeYears = 5;
export const maxMarketingGoalRangeDays = maxMarketingGoalRangeYears * 366;
export const marketingGoalRecentActivityLimit = 10;
export const marketingGoalActivityFeedLimit = 200;
export const maxGoalUpsertMarketers = 100;
export const goalMetricItemLinkKinds = [
    "placement",
    "homeCare",
    "referenceContact",
    "referenceBusiness",
    "community",
];
//# sourceMappingURL=marketing-goal.js.map